import React from "react";
import { ButtonBase, Stack, Typography } from "@mui/material";

export default function NetworkTabs({ value = "messages", onChange }) {
  return (
    <Stack
      direction="row"
      spacing={0.75}
      sx={{
        p: 0.5,
        borderRadius: "999px",
        border: "1px solid rgba(220, 230, 240, 0.95)",
        backgroundColor: "#f7f9fc",
        width: "fit-content",
      }}
    >
      {[
        { key: "moments", label: "Moments" },
        { key: "messages", label: "Messages" },
      ].map((item) => {
        const active = item.key === value;
        return (
          <ButtonBase
            key={item.key}
            onClick={() => onChange(item.key)}
            sx={{
              borderRadius: "999px",
              px: 1.8,
              py: 0.9,
              backgroundColor: active ? "#ffffff" : "transparent",
              boxShadow: active ? "0 6px 18px rgba(15, 23, 42, 0.08)" : "none",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: active ? 800 : 700,
                color: active ? "#17345d" : "#6b7a90",
              }}
            >
              {item.label}
            </Typography>
          </ButtonBase>
        );
      })}
    </Stack>
  );
}
